import { render, staticRenderFns } from "./BayItemInfo.vue?vue&type=template&id=c4a35d8e&scoped=true&"
import script from "./BayItemInfo.vue?vue&type=script&lang=js&"
export * from "./BayItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./BayItemInfo.vue?vue&type=style&index=0&id=c4a35d8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a35d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a35d8e')) {
      api.createRecord('c4a35d8e', component.options)
    } else {
      api.reload('c4a35d8e', component.options)
    }
    module.hot.accept("./BayItemInfo.vue?vue&type=template&id=c4a35d8e&scoped=true&", function () {
      api.rerender('c4a35d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/BayItemInfo.vue"
export default component.exports